import React, { useEffect, useState } from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { Button, TextField, ImageUploadWithPreview } from 'src/components';
import Service from 'src/setup/network';
import { toastAlert } from 'src/utils/toastAlert';
import { shallowEqual, useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { RootState } from 'src/redux/reducers';
import { fetchSetting } from 'src/redux/action/setting.action';
import { IoIosClose } from 'react-icons/io';
import Loader from 'src/components/loader';

interface IProps {}

const FORM_VALIDATION = Yup.object().shape({
  name: Yup.string()
    .min(3, 'Username must a at least 3 character long')
    .required('Username is required'),
  email: Yup.string()
    .email()
    .typeError('Please enter a valid email address')
    .required('Email is required'),
  // image: Yup.string(),
});

const AccountInfoTab: React.FC<IProps> = ({}) => {
  const dispatch = useDispatch();
  const [isHidden, setIsHidden] = useState(false);
  const onClick = () => {
    setIsHidden(!isHidden);
  };

  const { settingData, loading, error } = useSelector(
    ({ settingData }: RootState) => settingData,
    shallowEqual
  );

  React.useEffect(() => {
    // if (settingData.settings.loyaltyPoints.length > 0) return;
    dispatch(fetchSetting() as any);
  }, [dispatch]);

  const initValues = {
    image: settingData && settingData?.adminInfo?.image,
    name: settingData && settingData?.adminInfo?.name,
    email: settingData && settingData?.adminInfo?.email,
  };
  const [previewImage, setPreviewImage] = React.useState<any>(
    settingData ? settingData?.adminInfo?.image : null
  );
  const { userData } = useSelector(({ authReducer }: any) => authReducer);

  const handleSubmit = async (values: any, { resetForm }: any) => {
    const payload = {
      ...values,
    };
    try {
      await Service.post('/settings/admin', payload);
      toastAlert('success', `${values.name} is successfully edited`);
      dispatch(fetchSetting() as any);
      // resetForm();
    } catch (err: any) {
      toastAlert('error', err?.response?.data?.message);
    }
  };

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <Formik
          initialValues={initValues}
          validateOnMount
          validationSchema={FORM_VALIDATION}
          onSubmit={handleSubmit}
        >
          {({ setFieldValue, isSubmitting, isValid }) => (
            <Form>
              <div className="relative">
                <div className="z-90  mb-5">
                  <ImageUploadWithPreview
                    label="Profile Image"
                    previewImage={previewImage}
                    setPreviewImage={setPreviewImage}
                    setFieldValue={setFieldValue}
                  />
                </div>
              </div>
              <TextField label={'Username'} name="name" />
              <TextField label={'Email'} name="email" />
              <div className="flex items-center justify-end  mt-6">
                <Button
                  text="save information"
                  variant="primary"
                  type="submit"
                  isSubmitting={isSubmitting}
                  isValid={isValid}
                />
              </div>
            </Form>
          )}
        </Formik>
      )}
    </div>
  );
};

export default React.memo(AccountInfoTab);
